// API DateTimes are UTC but serialized without a timezone suffix (EF reads them
// as Kind=Unspecified), so `new Date(iso)` would wrongly parse them as local
// time. Append Z when no zone marker is present, then let the browser convert
// to the viewer's local time.
export const parseUtcDate = (iso: string): Date => {
  const hasZone = /(Z|[+-]\d{2}:?\d{2})$/.test(iso)
  return new Date(hasZone ? iso : `${iso}Z`)
}
